export default __webpack_public_path__ + "static/favicon-2abde8d01fc4224d2fb882f91e42df1a.png";